import React, {useEffect, useState} from 'react';
import Loader from '../../components/Loader';
import { useUser, isManager } from '../../contexts/UserContext';
import { dateFromTimestampToString } from '../../librairies/Dates';
import { useFirestoreCollection } from '../../librairies/Firestore';
import DataTable from '../table/Datatable';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import ToggleActivationLink from '../actions/ToggleActivationLink';
import AddOperateur from '../actions/AddOperateur';
import UpdateOperateur from '../actions/UpdateOperateur';

const ListOperateurs = () => {

  //contexte de l'utilisateur connecté
  const user = useUser();
  const { data: operateurs, loader } = useFirestoreCollection(`utilisateurs/${user.user.user.uid}/operateurs`, false);
  const [ajoutOperateur, popupAjoutOperateur] = useState(false);
  const [modifierSites, popupModifierSites] = useState(false);
  const [elementToUpdate, setElementToUpdate] = useState(null);

  const columns = [
    { header: 'Prénom', render: (operateur) => operateur.prenom },
    { header: 'Nom', render: (operateur) => operateur.nom },
    { header: 'Entreprise', render: (operateur) => operateur.entreprise },
    { header: 'Email', render: (operateur) => operateur.email },
    { header: 'Mot de passe', render: (operateur) => operateur.password },
    { header: 'Date de création', render: (operateur) => dateFromTimestampToString(operateur.dateCreation.seconds) },
    { header: 'Active', render: (operateur) => (operateur.active ? "Activé" : "Désactivé") },
    { header: 'Action', render: (operateur) => (
      <div className='flex gap-4'>
        <ToggleActivationLink collection={`utilisateurs/${user.user.user.uid}/operateurs`} item={operateur} available={true} /> 
        <a href="#" onClick={() => setElementToUpdate(operateur)} className="font-medium text-blue-600 dark:text-blue-500 hover:underline">Sites</a>
      </div>
    )}
  ];

  useEffect(()=>{
    if(elementToUpdate != null){
      popupModifierSites(true);
    }
  }, [elementToUpdate]);

  return (
    <div>
      {isManager(user.user) ? (
        <a href="#" onClick={() => popupAjoutOperateur(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Ajouter un opérateur"} loading={false} />
        </a>
      ) : null }

      {loader ? (
        <Loader />
      ) : (
        <DataTable 
          data={operateurs} 
          columns={columns} 
          onRowClick={(operateur) => console.log("operateur")}
        />
      )}

      {ajoutOperateur ? (
        <AddOperateur onClose={() => popupAjoutOperateur(false)} />
      ) : null }

      {modifierSites ? (
        <UpdateOperateur onClose={() => {setElementToUpdate(null); popupModifierSites(false); }} operateur={elementToUpdate} />
      ) : null }
    </div>
  );
};

export default ListOperateurs;
